import { render, staticRenderFns } from "./addFullReduction.vue?vue&type=template&id=1b64ab80&scoped=true&"
import script from "./addFullReduction.vue?vue&type=script&lang=js&"
export * from "./addFullReduction.vue?vue&type=script&lang=js&"
import style0 from "./addFullReduction.vue?vue&type=style&index=0&id=1b64ab80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b64ab80",
  null
  
)

export default component.exports